<script setup lang="ts">
const slug = "donnees-lecture-wreadia" as const;
const {
  public: { apiBase },
} = useRuntimeConfig();

type PageResponse = {
  title: string;
  hero_overline: string | null;
  hero_abstract: string | null;
  content: string; // HTML
  meta_description: string | null;
};

const { data: page, status, error } = await useAsyncData<PageResponse>(
  `static-page-${slug}`,
  () => $fetch(`${apiBase || ""}/api/page/${slug}`),
  { server: true }
);

useWreadiaSeo({
  title: () => page.value?.title || "Dans la tête de nos lectrices et lecteurs : les chiffres",
  description: () => page.value?.meta_description || "",
});

</script>
<template>
  <UPage id="pagePage" class="page-standard">
    <UPageBody id="pageBody">
      <UContainer class="max-w-[1024px]">
        <StaticPageHero
          v-if="page?.hero_abstract"
          :overline="page.hero_overline"
          :title="page.title"
          :abstract="page.hero_abstract"
        />
        <template v-else>
          <h1 class="text-h2">{{ page?.title || "Dans la tête de nos lectrices et lecteurs : les chiffres" }}</h1>
          <USeparator class="py-8"></USeparator>
        </template>
        <div v-if="status === 'pending'">Chargement…</div>
        <div v-else-if="error">
          <UAlert color="error" title="Impossible de charger cette page" :description="String(error)" />
        </div>
        <div v-else v-html="page?.content"></div>
      </UContainer>
    </UPageBody>
  </UPage>
</template>
